import { createChallenge } from '../helper/challenge-implementation-helper';
export class SmsPhoneOtpChallengeRequest {
    constructor(baseUrl, request) {
        this.baseUrl = baseUrl;
        this.request = request;
    }
    async createChallenge(options) {
        return createChallenge(this.baseUrl, this.request, options);
    }
}
/** @public */
export class SmsPhoneOtp {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }
    withScope(scope) {
        this.scope = scope;
        return this;
    }
    withRequestFrom(requestFrom) {
        this.requestFrom = requestFrom;
        return this;
    }
    withPhoneNumber(countryCode, number) {
        this.phoneNumber = {
            number,
            countryCode,
        };
        return this;
    }
    build() {
        const request = {
            authFactor: 'SMS_PHONE_OTP',
            scope: this.scope,
            requestFrom: this.requestFrom,
            payload: {
                phoneNumber: this.phoneNumber,
            },
        };
        return new SmsPhoneOtpChallengeRequest(this.baseUrl, request);
    }
}
//# sourceMappingURL=sms-phone-otp.js.map